
import { RevContainer } from '@ds/components/Container'
import isEmpty from 'lodash/isEmpty'

import Breadcrumb from '@app/components/Breadcrumb'
import BlockRenderer from '@cms/components/BlockRenderer.vue'
import Heading from '@cms/components/Heading'
import { intermediaryPath } from '@cms/helpers/breadcrumb'
import { PAGE_TYPE_BY_ROUTE_NAME } from '@cms/service/content-service.config'
import { MODAL_NAMES } from '@config/constants'
import { ROUTES } from '@router'

import translations from './LegalTemplate.translations'
import Modal from './components/Modal'
import ModalTrigger from './components/ModalTrigger'
import PDFLink from './components/PDFLink'

export default {
  components: {
    BlockRenderer,
    Heading,
    Modal,
    ModalTrigger,
    PDFLink,
    RevContainer,
    Breadcrumb,
  },

  inheritAttrs: false,

  props: {
    pageType: {
      type: String,
      required: true,
    },
    blocks: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    titleBreadcrumb: {
      type: String,
      required: true,
    },
    parentPageInfos: {
      type: Object,
      default: () => {},
    },
    pdf: {
      type: Object,
      default: () => ({}),
    },
    legalDocuments: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    translations: () => translations,
    modalName: () => MODAL_NAMES.LEGAL.LEGAL_DOCUMENTS_LIST,
    ctaClasses: () =>
      'w-full md:w-auto grid gap-4 auto-cols-fr md:grid-flow-col md:gap-6',
    documentsLinksLabel() {
      return this.$t(translations.documentsLinks)
    },
    hasDocumentsLinks() {
      return !isEmpty(this.legalDocuments)
    },
    hasPdfLink() {
      return !isEmpty(this.pdf)
    },
    hasCta() {
      return this.hasDocumentsLinks || this.hasPdfLink
    },
    hasBottomCta() {
      return this.hasCta && !isEmpty(this.blocks)
    },
    breadcrumb() {
      return {
        currentPageTitle: this.titleBreadcrumb,
        intermediaryPath: intermediaryPath({
          pageType: this.pageType,
          parentPageInfos: this.parentPageInfos,
        }),
      }
    },
  },

  beforeMount() {
    if (
      this.pageType ===
        PAGE_TYPE_BY_ROUTE_NAME[ROUTES.CMS.LEGAL_PREVIOUS_VERSION] &&
      isEmpty(this.blocks) &&
      !isEmpty(this.pdf)
    ) {
      this.$navigation.push({ type: 'external', href: this.pdf.url })
    }
  },
}
